import { useCallback, useState } from 'react';
import { useViewTableData, useAzureStorage, useHandleRequest, domHelper, skeletonFactory } from 'shared';
import { analyticsReports } from 'services';
import { CONTAINERS } from 'pages/shared';

const reportsDummy = skeletonFactory.analyticsReports();

export function useAnalyticsReportsPaginated() {
  const { getReadSasToken } = useAzureStorage(CONTAINERS.ANALYTICS_REPORTS);
  const {
    data: reportsData,
    get: getReports,
    deleteElements: deleteReports,
    errorInfo: getDeleteErrorKey,
    setErrorInfo
  } = useViewTableData({
    service: analyticsReports,
    paginatedSkeleton: reportsDummy
  });
  const { request, errorInfo: actionErrorInfo, setErrorInfo: setActionErrorInfo } = useHandleRequest();
  const [isSending, setIsSending] = useState(false);

  async function handleDownload([documentUrl, documentFileName]) {
    if (documentUrl) {
      const token = await getReadSasToken();
      const downloadUrl = documentUrl + '?' + token;
      domHelper.downloadFile(downloadUrl, documentFileName.replace(' ', '_'));
    }
  }

  const sendByMail = useCallback(
    async filters => {
      try {
        return await request(async () => {
          setIsSending(true);
          return await analyticsReports.sendByMail(filters);
        }, false);
      } catch {
      } finally {
        setIsSending(false);
      }
    },
    [request]
  );

  return {
    reports: reportsData,
    getReports,
    handleDownload,
    deleteReports,
    sendByMail,
    errorInfo: getDeleteErrorKey,
    setErrorInfo,
    actionErrorInfo,
    setActionErrorInfo,
    isSending
  };
}
